export default {
    device_status_account: "Account",
    device_status_unit_id: "Unit Id",
    device_status_age: "Age (Days)",
    device_status_event: "Event",
    device_status_last_readings: "Last Reading",
    device_status_no_data_message: "No data to present",
    device_status_status: "Status",
    device_status_manufacturer: "Manufacturer",
    device_status_serial: "Serial",
}